import Coborrower from '../cards/coborrower';
import Cohabitate from '../cards/cohabitation';
import CreditScore from '../cards/credit-score';
import DownPayment from '../cards/down-payment';
import { PrimaryBorrowerEmail } from '../cards/email';
import Occupancy from '../cards/occupancy';
import WelcomeCard from '../cards/welcome/affordability';
import { Branch, Card, End } from '../components/deck';
import { creditAuthorizationBranch } from './branches/credit-authorization';
import disqualifyingBranch from './branches/disqualifying';
import employmentBranch from './branches/employment';
import hasAgentBranch from './branches/has-agent';
import { AffordabilityStateVerification } from './branches/state-verification';
import timeToPurchaseNoOffer from './branches/time-to-purchase-no-offer';

export default Card(
  WelcomeCard,
  AffordabilityStateVerification(
    Card(
      Occupancy,
      Card(
        DownPayment,
        employmentBranch(
          'borrower',
          Card(
            CreditScore,
            Card(
              Coborrower,
              Branch(
                {
                  coborrower: Card(Cohabitate, employmentBranch('coborrower'))
                },
                ({ model }) => (model.getIn(['loan', 'hasCoborrower']) ? 'coborrower' : null),
                disqualifyingBranch(
                  hasAgentBranch(
                    timeToPurchaseNoOffer(
                      creditAuthorizationBranch(Card(PrimaryBorrowerEmail(), End()))
                    )
                  )
                )
              )
            )
          )
        )
      )
    )
  )
);



// WEBPACK FOOTER //
// ./src/decks/affordability.js